import React from "react";
import { Text } from "../common";

const TextBodyAccordion = (props) => <Text {...props} textSize="sm" />;

TextBodyAccordion.propTypes = {};

export default TextBodyAccordion;
